import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Leaf, Award, Earth } from 'lucide-react';
import { ABOUT_FEATURES, IMAGES } from '../data/homeData';

const ICONS = { leaf: Leaf, award: Award, earth: Earth };

function About() {
  return (
    <section className="about" id="about">
      <div className="about-grid">
        <div className="about-visual">
          <div className="about-img-wrap">
            <div className="about-img-main">
              <img
                src={IMAGES.aboutMain}
                alt="Swarvinn Impex team packaging Indian rice and groceries for UK export"
                loading="lazy"
              />
            </div>
            <div className="about-img-inset">
              <img
                src={IMAGES.aboutInset}
                alt="Retail spice packs and rice prepared for UK wholesale orders"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <div className="about-content">
          <span className="reveal section-eyebrow">— About Swarvinn Impex</span>
          <h2 className="reveal section-heading">
            Your India-to-UK partner for wholesale grocery import
          </h2>
          <p className="reveal section-body">
            Swarvinn Impex Ltd exports authentic Indian rice, spices, pulses, flours,
            and oils from Tamil Nadu to wholesalers and retailers across the United Kingdom —
            with FSSAI-certified quality, private labelling, and full export documentation.
          </p>

          <div className="feature-list">
            {ABOUT_FEATURES.map((f) => {
              const Icon = ICONS[f.icon];
              return (
                <div key={f.title} className="reveal feature-row">
                  <div className="feature-icon-wrap">
                    <Icon size={20} />
                  </div>
                  <div>
                    <h3>{f.title}</h3>
                    <p>{f.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>

          <Link to="/about-us" className="about-read-more reveal">
            View full company profile
            <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}

export default About;
